// src/components/FormLabel.js
import React from "react";

const FormLabel = ({ htmlFor, children, isRequired }) => {
    return (
        <label
            htmlFor={htmlFor}
            className="text-sm text-slate-700 font-medium flex items-center gap-1"
        >
            {children}
            {isRequired && <span className="text-red-600">*</span>}
        </label>
    );
};

export default FormLabel;
